module.exports = __webpack_public_path__ + "static/img/report_img_gjaqxsfxbg.d83b041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_gjaqxsfxbg.png
// module id = qusX
// module chunks = 21